export const REPLY_EDITOR_MODES = {
  REPLY: 'REPLY',
  SUGGESTION: 'SUGGESTION',
  NOTE: 'NOTE',
};

export const CHAR_LENGTH_WARNING = {
  UNDER_50: 'characters remaining',
  NEGATIVE: 'characters over',
};
